export default {
    drag_and_drop: 'Drag and drop to upload your images or',
    browse_files: 'Browse files',
    your_uploads: 'Your uploads',
    allowed_types: 'Allowed types: .png .jpg .jpeg',
    wrong_file_type: 'Some of your images has wrong file type. \n Allowed types: .png .jpg .jpeg',
    max_number: 'Maximum number of files is: {n}',
    files_over_limit: 'Max limit per file is: {n}MB',
    add_image_here: 'Add an image here',
    cant_delete_main_image: 'Main image can not be removed! Please select another image for main and then remove this one.',
    set_main: 'Set as main',
    invalid_image: "Some of your images are invalid. They won't be uploaded!",
    invalid_file: 'Invalid file',
}
